import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const NewYorkTimes = ({featuredProjectsList}) => {
  const project = getProject('nyt');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '215916994'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            The New York Times and International Herald Tribune enlisted Your
            Majesty to help build an online platform, allowing their editorial
            teams to create and publish custom conferences that fit into a
            cohesive, expandable experience.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170510000803/slide11.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="process">Process</h2>
          <p>
            Producing this new platform began with a deep-dive workshop that
            brought together all stakeholders to solve sponsorship objectives
            and authoring pain points. In parallel, Your Majesty rapidly
            prototyped the new, modular solution, so we could test and iterate.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170510000805/slide2.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="one-hub-for-them-all">One hub for them all</h2>
          <p>
            Planning a conference has several stages, starting with
            registration, to securing location and speakers, to the days of, and
            thereafter. The final product enabled editors to easily build
            (regardless of stage) a new conference in under a minute, that is
            consistent with the hub, yet allows customization for each
            conference to be unique.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170510000807/slide3.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170510000809/slide5.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170510000811/slide6.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="for-conference-goers">For conference goers</h2>
          <p>
            This is where the predefined conference stages come into play –
            helping attendees easily get informed and register <em>before</em>,
            view agendas and locations <em>during</em>, and sift through
            summaries <em>after</em>.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170510000808/slide4.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170510000813/slide7.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170510000814/slide8.jpg'
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Interviews & User Testing',
                  'Prototyping & Validation',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: ['Art Direction', 'UI/UX Design', 'Visual Design']
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Content Management System',
                  'Front-end Development'
                ]
              },

              {
                title: 'Delivery',
                items: ['Integration Support', 'Staff Training & Support']
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default NewYorkTimes;
